import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import Badge from 'eventbrite_design_system/badge/Badge';
import CheckChunkySvg from 'eventbrite_design_system/iconography/icons/CheckChunky';
import Carousel from 'eventbrite_design_system/carousel/Carousel';
import FeaturedCircleSVG from './FeaturedCircleSVG';

import {
    COLLECTIONS_PROPTYPES,
    GA_SCROLL_COLLECTIONS_ACTION,
    GA_CLICK_VIEW_COLLECTION_ACTION,
} from './constants';

import './collectionsBucket.scss';

const BotCollectionContent = ({ collectionContent }) => (
    <div className="collections-bucket__bot-container">
        {collectionContent.map(({ id, name }) => (
            <div className="collections-bucket__collection-link">
                <a href={`/c/${id}`} target="_blank">
                    {' '}
                    {gettext('%(name)s Collection', {
                        name,
                    })}
                </a>
            </div>
        ))}
    </div>
);

const CollectionContent = ({
    id,
    imageUrl,
    name,
    summary,
    eventCount,
    creatorImage,
    handleCollectionClick,
}) => (
    <div className="collections-bucket__collection-content">
        <div className="collections-bucket__image-mask-container">
            {imageUrl && (
                <img
                    className="collections-bucket__image-mask"
                    src={imageUrl}
                    alt="collection cover background"
                />
            )}
        </div>
        <div
            className="collections-bucket__collection-image"
            style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : {}}
        />
        <div className="collections-bucket__info-container eds-bg-color--background eds-l-pad-vert-6 eds-l-pad-hor-4">
            <div className="eds-align--center-vertical">
                <div className="collections-bucket__creator-section">
                    {creatorImage && (
                        <img
                            className="collections-bucket__creator-image"
                            src={creatorImage}
                            alt="creator"
                            width="48px"
                            height="48px"
                        />
                    )}
                    <span className="collections-bucket__creator-badge">
                        <Badge iconType={<CheckChunkySvg />} />
                    </span>
                </div>
                <div className="eds-l-mar-left-4">
                    <h3 className="eds-text-hs">{name}</h3>
                </div>
            </div>
            <p className="eds-text-bm eds-l-pad-vert-6">{summary}</p>
            <a
                className="eds-btn eds-btn--link eds-btn--neutral eds-btn--block"
                href={`/c/${id}/`}
                onClick={handleCollectionClick}
            >
                {eventCount === 0
                    ? gettext('View Events')
                    : gettext('View %(eventCount)s Upcoming Events', {
                          eventCount,
                      })}
            </a>
        </div>
    </div>
);

export default class CollectionsBucket extends React.Component {
    static propTypes = {
        currentPlace: PropTypes.string,
        content: COLLECTIONS_PROPTYPES,
        trackGAEventOnPageUnload: PropTypes.func,
        trackGAEvent: PropTypes.func,
        isBotRequest: PropTypes.bool,
    };

    static defaultProps = {
        content: [],
    };

    handleCollectionClick = (id) => {
        const { trackGAEventOnPageUnload } = this.props;

        if (trackGAEventOnPageUnload) {
            trackGAEventOnPageUnload({
                action: GA_CLICK_VIEW_COLLECTION_ACTION,
                label: id,
            });
        }
    };

    _handleTransition = (index) => {
        const { content, trackGAEvent } = this.props;
        const collectionId = content[index].id;

        if (trackGAEvent) {
            trackGAEvent({
                action: GA_SCROLL_COLLECTIONS_ACTION,
                label: collectionId,
                value: index,
            });
        }
    };

    render() {
        const { currentPlace, content, isBotRequest } = this.props;

        if (isBotRequest) {
            return <BotCollectionContent collectionContent={content} />;
        }
        return (
            <div className="collections-bucket__container">
                <div className="collections-bucket__featured-circle-container">
                    <FeaturedCircleSVG />
                </div>
                <div className="collections-bucket__carousel-container">
                    <Carousel
                        alwaysShowSideNavigation={true}
                        hasTopControls={true}
                        usesNewStyle={true}
                        isNotContinuous={true}
                        title={gettext('Our favorite collections')}
                        subtitle={gettext(
                            'Browse through some of the best collections in %(currentPlace)s hand picked by people who know the area best.',
                            { currentPlace },
                        )}
                        onTransition={this._handleTransition}
                    >
                        {content.map(
                            ({
                                id,
                                imageLarge = {},
                                name,
                                creator: { image = {} },
                                summary,
                                eventCount,
                                creatorImageIdOverrideUrl,
                            }) => (
                                <CollectionContent
                                    id={id}
                                    key={`collection-${id}`}
                                    imageUrl={imageLarge.url}
                                    name={name}
                                    summary={summary}
                                    eventCount={eventCount}
                                    creatorImage={
                                        creatorImageIdOverrideUrl
                                            ? creatorImageIdOverrideUrl
                                            : image.url
                                    }
                                    handleCollectionClick={this.handleCollectionClick.bind(
                                        this,
                                        id,
                                    )}
                                />
                            ),
                        )}
                    </Carousel>
                </div>
            </div>
        );
    }
}
